import { Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators
} from "@angular/forms";
import {
  AlertController,
  LoadingController,
  ToastController,
  Platform
} from "@ionic/angular";

import { Stylist } from "../../models/stylist/stylist.model";
import { Salon } from "../../models/salon/salon.model";
import { UserService } from "../../services/user.service";
import { StylistService } from "../../services/stylist.service";
import {
  CustomizedEmailService,
  CustomizedEmails
} from "../../services/customized-email.service";
import { SalonService } from "../../services/salon.service";
import { Utilities } from "../../utilities/utilities";
import { List } from "immutable";
import { switchMap } from 'rxjs/operators';
import { StylistPickerComponent } from "../../components/stylist-picker/stylist-picker.component";
import {
  AwsBucketManagerProvider,
  S3DirName
} from "../../services/aws-bucket-manager.service";
import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';
import {Router} from '@angular/router';
import { QuillModule } from 'ngx-quill';

@Component({
  selector: 'app-custom-email-settings',
  templateUrl: './custom-email-settings.page.html',
  styleUrls: ['./custom-email-settings.page.scss'],
})

export class CustomEmailSettingsPage {
  //@ViewChild(Content) content: Content;

  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  public isLoadingPage: boolean;

  public errorOccurredWhileLoadingPage: boolean;

  public isLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public submitted: boolean;

  public savingInProgress: boolean;

  public stylistID: number;

  public stylist: Stylist;

  public readOnlyStylistPicker: boolean;

  public salonCustomizedEmails: CustomizedEmails;

  public settingsForm: UntypedFormGroup;

  public sameCustomizedEmailsForAllStaff: UntypedFormControl;

  public bookingRequest: UntypedFormControl;

  public bookingConfirmation: UntypedFormControl;

  public bookingCancelled: UntypedFormControl;

  public bookingReminder: UntypedFormControl;

  public platform: Platform;
  public screenSize: number;

  public config: QuillModule = {
    toolbar: [
      { font: [] },
      { header: [1, 2, 3, 4, 5, 6, false] },
      { size: [] },
      "divider",
      "bold",
      "italic",
      "underline",
      "strike",
      "divider",
      { list: "ordered" },
      { list: "bullet" },
      // 'divider',
      { indent: "-1" },
      { indent: "+1" },
      { align: [] },
      "divider",
      { color: [] },
      { background: [] },
      "clean",
      "divider",
      "link",
      "image",
      "video"
    ]
  };

  constructor(
    //private navCtrl: NavController,
    private router: Router,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private alertCtrl: AlertController,
    private stylistService: StylistService,
    private customizedEmailService: CustomizedEmailService,
    private salonService: SalonService,
    private toastController: ToastController,
    private awsBucketManager: AwsBucketManagerProvider,
    private readonly alertService: AlertService,
    private loadingCtrl: LoadingController,
    private readonly toastService: ToastService,
   
  ) {
    this.isLoadingStylistPicker = true;
    this.submitted = false;
    this.savingInProgress = false;
    this.sameCustomizedEmailsForAllStaff = new UntypedFormControl(
      this.userService.getSalon().sameCustomizedEmailsForAllStaff === 1
    );
    this.bookingRequest = new UntypedFormControl("");
    this.bookingConfirmation = new UntypedFormControl("");
    this.bookingCancelled = new UntypedFormControl("");
    this.bookingReminder = new UntypedFormControl("");

    this.settingsForm = this.formBuilder.group({
      sameCustomizedEmailsForAllStaff: this.sameCustomizedEmailsForAllStaff,
      bookingRequest: this.bookingRequest,
      bookingConfirmation: this.bookingConfirmation,
      bookingCancelled: this.bookingCancelled,
      bookingReminder: this.bookingReminder
    });

    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      if (user.isAdministrator()) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
    }
  }

  public ngOnInit() {
    this.loadPage();
  }
  

 

  public loadPage() {
    this.isLoadingPage = true;
    this.errorOccurredWhileLoadingPage = false;
    this.customizedEmailService.loadSalonCustomizedEmails().subscribe(
      result => {
        const customizedEmail = result.get(0);
        this.salonCustomizedEmails = customizedEmail;

        if (this.sameCustomizedEmailsForAllStaff.value) {
          this.bookingRequest.setValue(customizedEmail.bookingRequest);
          this.bookingConfirmation.setValue(
            customizedEmail.bookingConfirmation
          );
          this.bookingCancelled.setValue(customizedEmail.bookingCancelled);
          this.bookingReminder.setValue(customizedEmail.bookingReminder);
        }

        this.isLoadingPage = false;
      },
      err => {
        this.isLoadingPage = false;
        this.errorOccurredWhileLoadingPage = true;
      }
    );
  }

  public onToggleChange($event) {
    this.isLoadingStylistPicker = false;
    this.errorOccurredWhileLoadingStylistPicker = false;

    if ($event.value) {
      this.bookingRequest.setValue(this.salonCustomizedEmails.bookingRequest);
      this.bookingConfirmation.setValue(
        this.salonCustomizedEmails.bookingConfirmation
      );
      this.bookingCancelled.setValue(
        this.salonCustomizedEmails.bookingCancelled
      );
      this.bookingReminder.setValue(this.salonCustomizedEmails.bookingReminder);
    } else {
    }
  }

  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoadingStylistPicker = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
      //this.content.resize();
    }
  }

  public onTapToReloadStylistPicker() {
    this.isLoadingStylistPicker = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public onStylistSelect(stylist: Stylist) {
    // this.isLoadingStylistPicker = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    if (stylist) {
      this.stylistID = stylist.getID();
      this.stylist = stylist;

      this.customizedEmailService
        .loadStylistCustomizedEmails(this.stylist.getID())
        .subscribe({
          next:(result) => {
            const customizedEmail = result.get(0);
            this.bookingRequest.setValue(customizedEmail.bookingRequest);
            this.bookingConfirmation.setValue(
              customizedEmail.bookingConfirmation
            );
            this.bookingCancelled.setValue(customizedEmail.bookingCancelled);
            this.bookingReminder.setValue(customizedEmail.bookingReminder);
            this.isLoadingStylistPicker = false;
          },
          error: (e) => {
            this.isLoadingStylistPicker = false;
            this.errorOccurredWhileLoadingStylistPicker = true;
          }
    });
    }
  }

  private uploadImagesToBucket(): Promise<any> {
    let bookingTexts = {
      bookingRequest: { text: "", status: true, title: "Booking Request" },
      bookingConfirmation: {
        text: "",
        status: true,
        title: "Booking Confirmation"
      },
      bookingCancelled: { text: "", status: true, title: "Booking Cancelled" },
      bookingReminder: { text: "", status: true, title: "Booking Reminder" }
    };

    return this.awsBucketManager
      .extractBase64AndUpload(
        this.bookingRequest.value,
        S3DirName.CUSTOM_EMAIL_BOOKING_REQUEST
      )
      .then(result => {
        bookingTexts.bookingRequest.text = result;

        return this.awsBucketManager
          .extractBase64AndUpload(
            this.bookingConfirmation.value,
            S3DirName.CUSTOM_EMAIL_BOOKING_CONFIRMATION
          )
          .then(result => {
            bookingTexts.bookingConfirmation.text = result;

            return this.awsBucketManager
              .extractBase64AndUpload(
                this.bookingCancelled.value,
                S3DirName.CUSTOM_EMAIL_BOOKING_CANCELLED
              )
              .then(result => {
                bookingTexts.bookingCancelled.text = result;

                return this.awsBucketManager
                  .extractBase64AndUpload(
                    this.bookingReminder.value,
                    S3DirName.CUSTOM_EMAIL_BOOKING_REMINDER
                  )
                  .then(result => {
                    bookingTexts.bookingReminder.text = result;
                    return bookingTexts;
                  })
                  .catch(err => {
                    bookingTexts.bookingReminder.status = false;
                    return bookingTexts;
                  });
              })
              .catch(err => {
                bookingTexts.bookingCancelled.status = false;
                return bookingTexts;
              });
          })
          .catch(err => {
            bookingTexts.bookingConfirmation.status = false;
            return bookingTexts;
          });
      })
      .catch(err => {
        bookingTexts.bookingRequest.status = false;
        return bookingTexts;
      });
  }

  public async onSettingsSave() {
    this.submitted = true;

    if (this.settingsForm.valid === false) {
      return;
    }

        const loader = await this.loadingCtrl.create({
        spinner: 'crescent',
      });

      loader.present();


    let salon: Salon = this.userService.getSalon();
    salon = salon.setSameCustomizedEmailsForAllStaff(
      this.sameCustomizedEmailsForAllStaff.value ? 1 : 0
    );

    this.uploadImagesToBucket()
      .then(bookingTexts => {

        const customizedEmails: CustomizedEmails = {
          bookingRequest: bookingTexts.bookingRequest.text,
          bookingConfirmation: bookingTexts.bookingConfirmation.text,
          bookingCancelled: bookingTexts.bookingCancelled.text,
          bookingReminder: bookingTexts.bookingReminder.text
        };

        this.savingInProgress = true;

        this.salonService
          .saveSalon(salon)
          .pipe(switchMap(salon => {
            this.userService.setSalon(salon);

            if (this.sameCustomizedEmailsForAllStaff.value) {
              return this.customizedEmailService.saveSalonCustomizedEmails(
                customizedEmails
              );
            } else {
              return this.customizedEmailService.saveStylistCustomizedEmails(
                this.stylist.getID(),
                customizedEmails
              );
            }
          }))
          .subscribe({
            next:(result) => {
              loader.dismiss().then(() => {
                this.savingInProgress = false;
                this.submitted = false;

                if (!this.sameCustomizedEmailsForAllStaff.value) {
                  this.stylistService.updateStylist(this.stylist);
                }

                this.toastService.presentSimpleToast(`Your custom email settings have been successfully updated.`, 3000);
                //this.navCtrl.pop();
                this.router.navigateByUrl('/settings');
              });
            },
            error: (e) => {

              loader.dismiss().then(() => {
                this.savingInProgress = false;
                this.alertService.presentErrorAlert();
              });
            }
      });
      })
      .catch(bookingTexts => {
        let error = bookingTexts.filter(value => !value.status)[0];
        loader.dismiss().then(() => {
          this.savingInProgress = false;
         // let errorMessage = Utilities.getDefaultErrorMessageConfig();
          const errorMessage =
            `Oops! An error occured on ` +
            error.title +
            `, if this problem persists please contact our <a href="http://support.salonmonster.com">support</a>.`;
          //this.alertCtrl.create(errorMessage).present();
          this.alertService.presentErrorAlert(errorMessage);
        });
      });
  }

  public onBack() {
    //this.navCtrl.pop();
    this.router.navigateByUrl('/settings');
  }

  testUpload() {}
} 
